import React from 'react';
import { useParams } from 'react-router-dom';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDateTime } from '../../../../utils/fmt';

function buildHeaders() {
  const token = localStorage.getItem('customer_management_token');
  const tenantId = localStorage.getItem('crm_tenant_id');
  const tenantToken = localStorage.getItem('crm_tenant_token');
  return {
    ...(token ? { Authorization: `Token ${token}` } : {}),
    ...(tenantId ? { 'X-Tenant-ID': tenantId } : {}),
    ...(tenantToken ? { 'X-Tenant-Token': tenantToken } : {}),
  };
}

const downloadFile = async (filePath) => {
  if (!filePath) return;
  const url = filePath.startsWith('http')
    ? filePath
    : `${API_DOMAIN}${filePath.replace(/^\/+/, '')}`;
  const filename = filePath.split('/').pop();
  try {
    const res = await fetch(url, { headers: buildHeaders() });
    if (!res.ok) throw new Error(res.status);
    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(objectUrl);
  } catch (err) {
    console.error('Download failed:', err);
  }
};

const CustomerDocumentList = () => {
  const { activityId } = useParams();

  const decodedActivityId = activityId ? atob(activityId).replace(/\D/g, '') : '';
  const fetchUrl = decodedActivityId
    ? `${API_DOMAIN}${API_ROUTES.customerDocument}?activity=${decodedActivityId}`
    : `${API_DOMAIN}${API_ROUTES.customerDocument}`;

  const columns = [
    {
      label: 'File',
      value: (item) => {
        if (!item.file) return '—';
        const filename = item.file.split('/').pop();
        return (
          <button
            onClick={() => downloadFile(item.file)}
            style={{
              background: 'none', border: 'none', padding: 0, cursor: 'pointer',
              color: 'var(--color-primary)', fontSize: 'inherit', textAlign: 'left',
            }}
          >
            📄 {filename}
          </button>
        );
      },
    },
    { label: 'Uploaded At', value: (item) => fmtDateTime(item.uploaded_at) },
    { label: 'Activity', value: item => item.activity?.subject || 'N/A' },
  ];

  const handleAccessDetails = (id) => {
    window.location.href = `/customer/document/details/${id}`;
  };

  return (
    <div>
      <h1>Customer Documents</h1>
      <ListTemplate
        fetchUrl={fetchUrl}
        columns={columns}
        onAccessDetails={handleAccessDetails}
      />
    </div>
  );
};

export default CustomerDocumentList;
